import { CountryEnum } from "Infrastructure/Api/Api";
import { z } from "zod";
import { buildingNumberSchema } from "./common";

export const getPartnerAddressInfoSchema = () => {
	return z.object({
		street: z.string().nullish(),
		buildingNumber: buildingNumberSchema(10),
		postCode: z.string().nullish(),
		city: z.string().nullish(),
		country: z.nativeEnum(CountryEnum),
	});
};

export type PartnerAddressInfoFormModel = z.infer<
	ReturnType<typeof getPartnerAddressInfoSchema>
>;
